
const PbdsFooterPbShopDark = {
    init: function() {

        console.log('PbdsFooterPbShopDark started');

        
    },

};

export default () => {
   	PbdsFooterPbShopDark.init();    
};